import { StyledLink } from "../utils/button";

const PaystackHook = () => {
  return (
    <div className="complete-pay">
      <StyledLink
        as="button"
        type="submit"
      >
        Complete Payment
      </StyledLink>
    </div>
  );
};

export default PaystackHook;
